import React from 'react';
import {Modal} from 'react-bootstrap';
import {assets} from '../../../../../utils/assetsSrc';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import TextField from '../../../../../components/form/textfield/textfield';
import Button from '../../../../../components/form/button/button';
import {useLocation} from 'react-router-dom';
import {
  assessmentTypeIds,
  riskAssessmentAccessIds,
} from '../../../../../utils/constants';
import './newCybersecurityAssessment.scss';

export default function NewCybersecurityAssessment({
  show,
  setShow,
  handleRiskAssessmentAction,
}) {
  const location = useLocation();

  const initialValues = {
    name: '',
  };

  const validate = Yup.object({
    name: Yup.string().required('Name is Required'),
  });

  const handleSubmit = values => {
    const payload = {
      name: values.name.trim(),
      access: riskAssessmentAccessIds.normal,
      users: [],
      product: location.state?.selectedProductLine?.id,
      machine: [location.state?.selectedModelId],
      type: assessmentTypeIds.cybersecurity,
    };
    handleRiskAssessmentAction(payload);
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      aria-labelledby="new-cybersecurity-assessment"
      centered
      className="new-cybersecurity-assessment">
      <Modal.Body className="p-5 px-5 text-center">
        <div className="header">
          <p className="label mt-3 mb-4">New Cybersecurity Assessment</p>
          <img onClick={() => setShow(false)} src={assets.closeIcon} />
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validate}
          onSubmit={handleSubmit}>
          {() => (
            <Form>
              <div className="cybersecurity-assess-row">
                <TextField
                  name="name"
                  type="text"
                  label="Cybersecurity assessment name"
                  placeholder="Name of Cybersecurity Assessment"
                />
              </div>
              <div className="action-buttons">
                <Button
                  type="button"
                  clickHandler={() => setShow(false)}
                  variant="secondary-button">
                  Cancel
                </Button>
                <Button type="submit" variant="submit-button">
                  Create
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
